export default "__VITE_ASSET__Bh_YfJ1g__"